import { render } from "./payIdenfy.vue?vue&type=template&id=40256c7c&scoped=true"
import script from "./payIdenfy.vue?vue&type=script&lang=js"
export * from "./payIdenfy.vue?vue&type=script&lang=js"

import "./payIdenfy.vue?vue&type=style&index=0&id=40256c7c&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40256c7c"]])

export default __exports__